<template>
  <v-app id="inspire">
    <div v-if="pageType === 'intro'">
      <ServiceInit></ServiceInit>
    </div>
    <div v-else>
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        ref="appNavigation"
      >
        <v-list dense>
          <template v-for="item in items">
            <v-list-item
              :key="item.text"
              link
              :disabled="checkMenuDisabled(item)"
              @click="checkVersionAlret($event)"
            >
              <router-link class="navigation-router-link" :to="item.toPath">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <p class="subtitle-2 mb-0">{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </template>
        </v-list>
        <BrowerGuide></BrowerGuide>
      </v-navigation-drawer>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="blue darken-3"
        dark
        ref="appBar"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
          <span class="hidden-sm-and-down">{{ appTitle }}</span>
        </v-toolbar-title>
        <div v-if="CONFIG.NODE_ENV === 'development'">
          <v-btn
            color="warning"
            v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.ANY"
            @click.prevent="changeVersion(AUTH_SERVICE.APP_MODE.BASIC)"
          >사용종료(개발모드에서만 보임)</v-btn>
          <v-btn
            color="info"
            v-else
            @click.prevent="changeVersion(AUTH_SERVICE.APP_MODE.ANY)"
          >사용(개발모드에서만 보임)</v-btn>
        </div>
        <v-spacer />
        <AppVersion></AppVersion>
      </v-app-bar>
      <v-content>
        <v-container class="height" fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
      <ProgressDialog></ProgressDialog>
      <CircularProgress></CircularProgress>
      <Alert></Alert>
    </div>
  </v-app>
</template>

<style scoped>
.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}
.v-list-item--disabled {
  pointer-events: auto;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import ServiceInit from "@/views/authservice/ServiceInit.vue";
import BrowerGuide from "@/components/authservice/BrowserGuide.vue";
import AppVersion from "@/components/shoplus_service/version/AppVersion.vue";
import ProgressDialog from "@/components/common/ProgressDialog.vue";
import CircularProgress from "@/components/common/CircularProgress.vue";
import Alert from "@/components/common/Alert.vue";
import { AUTH_SERVICE } from "@/datas/authservice";
import { CONFIG } from "@/datas/configs.js";

export default {
  components: {
    ServiceInit,
    AppVersion,
    BrowerGuide,
    ProgressDialog,
    CircularProgress,
    Alert
  },
  props: {
    source: String
  },
  data() {
    return {
      AUTH_SERVICE,
      CONFIG,
      pageType: "intro",
      appTitle: "정품 인증 서비스",
      drawer: null,
      unPlus: {
        color: "#8C8C8C"
      },
      items: [
        {
          icon: "mdi-label-multiple-outline",
          text: "서비스 소개",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/serviceIntro`,
          version: AUTH_SERVICE.APP_MODE.ANY
        },
        {
          icon: "mdi-text-box-plus-outline",
          text: "상품 정보 관리/등록",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/manageProductInfo`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-cog-outline",
          text: "정품 보증 기간 설정",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/warrantyPeriod`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-barcode",
          text: "정품 인증 코드 생성",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/createAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-barcode-scan",
          text: "정품 인증 코드 관리",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/manageAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-qrcode",
          text: "정품 QR 코드 인쇄 설정",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/printqr`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-store",
          text: "쇼핑몰 정품 인증 설정",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/setting`,
          version: AUTH_SERVICE.APP_MODE.BASIC
        },
        {
          icon: "mdi-clipboard-plus-outline",
          text: "부가서비스",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/additionalService`,
          version: AUTH_SERVICE.APP_MODE.ANY
        },
        {
          icon: "mdi-credit-card-outline",
          text: "결제 관리",
          toPath: `/shoplus_authservice/${this.$store.state.mallId}/payment`,
          version: AUTH_SERVICE.APP_MODE.ANY
        }
      ]
    };
  },
  mixins: [CommonMixin],
  created: function() {
    document.title = "샵플러스 정품인증서비스";
    this.pageType =
      this.$router.app.path === "/shoplus_authservice/init" ? "intro" : "page";

    if (sessionStorage.shoplusAuthServiceMode == "basic") {
      this.$store.dispatch("CHANGE_VERSION", "basic");
    } else {
      this.$store.dispatch("CHANGE_VERSION", "any");
    }
  },
  methods: {
    changeVersion: function(version) {
      this.$store.dispatch("CHANGE_VERSION", version);
    },
    checkVersionAlret: function(e) {
      // disabled 클래스 체크하여 얼럿 띄우기
      let disabledEl = e.target.closest(".v-list-item--disabled");
      if (this.$store.state.mode === AUTH_SERVICE.APP_MODE.ANY) {
        if (disabledEl !== null) {
          this.alertShow(
            "사용 기간이 만료되었습니다.</br>결제 관리 메뉴에서 결제 후 사용이 가능합니다."
          );
          e.stopPropagation();
        }
      }
    },
    checkMenuDisabled: function(item) {
      let mode = this.$store.state.mode;
      if (mode === AUTH_SERVICE.APP_MODE.ANY) {
        if (item.version !== AUTH_SERVICE.APP_MODE.ANY) {
          item.toPath = "";
          return true;
        }
      } else {
        if (mode == AUTH_SERVICE.APP_MODE.BASIC) {
          return false;
        }
      }
      return false;
    }
  }
};
</script>
